"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SurveyResourceLog", {
    enumerable: true,
    get: function() {
        return SurveyResourceLog;
    }
});
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const SurveyChangeType = _zod.z.union([
    _zod.z.literal("publish"),
    _zod.z.literal("edit-dates"),
    _zod.z.literal("edit-schedule-dates"),
    _zod.z.literal("edit-questions"),
    _zod.z.literal("edit-name"),
    _zod.z.literal("edit-questions-and-name"),
    _zod.z.literal("close"),
    _zod.z.literal("delete"),
    _zod.z.literal("edit-participant-selection")
]);
const SurveyResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("survey"),
    change_type: _baseresourcelog.BaseResourceChangeType.or(SurveyChangeType)
});
